import React, { useEffect, useMemo, useRef, useState } from 'react';
import IconFont from '@/components/icon-font';
import classnames from 'classnames';
import { AnimatePresence, motion } from 'motion/react';
import { auraConfig, couponCardConfig, maskConfig, parentConfig } from './const';
import { CouponDiscount } from './coupon-discount';
import { RedEnvelopePromotion } from '@meitu/subscribe-core';
import { shouldShowRedEnvelopePopup, updateLocalRedEnvelopRecord } from '@/utils';

import styles from './index.module.css';
import { useAtom } from 'jotai';
import { activeProductMotionAtom, redEnvelopePromotionInfoAtom } from '@/store';

/**
 * 获取 el 中心位置
 * @param element el
 */
const getCenterPosition = (element?: Element) => {
  if (element) {
    const rect = element.getBoundingClientRect();

    const centerX = rect.left + rect.width / 2;
    const centerY = rect.top + rect.height / 2;

    return { x: centerX, y: centerY };
  }
  return { x: 0, y: 0 };
};

const RedEnvelope = () => {
  const [visible, setVisible] = useState(false);
  const [productLocation, setProductLocation] = useState({
    x: '0',
    y: '0',
  });

  const [redEnvelopePromotionInfo] = useAtom(redEnvelopePromotionInfoAtom);
  const [, setActiveProductMotion] = useAtom(activeProductMotionAtom);

  const couponCardRef = useRef<HTMLDivElement>(null);

  // 最多三个优惠券
  const redEnvelopePromotionList = (redEnvelopePromotionInfo?.redEnvelopePromotionList || []).slice(
    0,
    3
  );

  const handleClose = (type?: 'receive' | 'close') => {
    if (!visible) {
      return;
    }

    let productId = redEnvelopePromotionList[0].productId;

    const productCenter = getCenterPosition(document.querySelector(`#product-${productId}`)!);
    const couponCardCenter = getCenterPosition(couponCardRef.current!);

    // 红包弹窗收起 X 轴需要偏移距离
    const offsetX = productCenter.x - couponCardCenter.x;
    const offsetY = productCenter.y - couponCardCenter.y;

    setProductLocation({
      // 偏移距离大于 480 说明，第一个红包优惠商品不在可视区，则红包弹窗收到默认的中间位置
      x: `${offsetX > 480 ? 0 : offsetX}px`,
      y: `${offsetY}px`,
    });

    setTimeout(() => {
      setVisible(false);
      setActiveProductMotion(true);
      updateLocalRedEnvelopRecord();
    }, 100);
  };

  const popCouponModal = () => {
    setVisible(true);
  };

  // 红包弹窗 marginTop
  const couponMarginTop = useMemo(() => {
    if ((redEnvelopePromotionInfo?.redEnvelopePromotionList?.length || 0) < 3) {
      return 144;
    }

    return 180;
  }, [redEnvelopePromotionInfo?.redEnvelopePromotionList]);

  useEffect(() => {
    const status = shouldShowRedEnvelopePopup();
    if (status) {
      popCouponModal();
    }
  }, [redEnvelopePromotionInfo?.redEnvelopePromotionList.length]);

  if (!redEnvelopePromotionList.length) return null;

  return (
    <AnimatePresence>
      {visible && (
        <div>
          <motion.div variants={parentConfig} initial="initial" animate="show" exit="hidden">
            <motion.div
              ref={couponCardRef}
              custom={{
                couponMarginTop,
                productLocation,
              }}
              variants={couponCardConfig}
              style={{
                width: 280,
                height: 360,
                position: 'absolute',
                zIndex: 102,
                left: '50%',
                marginLeft: '-140px',
                top: '50%',
                marginTop: `-${couponMarginTop}px`,
                transformStyle: 'preserve-3d',
              }}
              className={classnames({
                [styles.singleCoupon]: redEnvelopePromotionList?.length === 1,
                [styles.twoCoupons]: redEnvelopePromotionList?.length === 2,
              })}
            >
              <div className={classnames(styles.card, styles.cardFront)}>
                <IconFont
                  className={styles.close}
                  name="crossBold"
                  fontSize={22}
                  onClick={() => handleClose('close')}
                ></IconFont>
                <div className={styles.title}>VIP限时特惠</div>
                {redEnvelopePromotionList?.map((item, index) => {
                  return (
                    <CouponDiscount
                      key={item.productId}
                      style={{ top: `${75 + index * 72}px` }}
                      promotion={item}
                      isSingleStyle={redEnvelopePromotionList?.length === 1}
                    />
                  );
                })}
                <div className={styles.button} onClick={() => handleClose('receive')}>
                  立即领取
                </div>
              </div>
              <div className={classnames(styles.card, styles.cardBack)} />
            </motion.div>
            <motion.div variants={auraConfig} className={styles.aura} />
          </motion.div>
          <motion.div
            variants={maskConfig}
            initial="initial"
            animate="show"
            exit="hidden"
            className={styles.mask}
          />
        </div>
      )}
    </AnimatePresence>
  );
};

export default RedEnvelope;
